import { ChartDatasetModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  ViewEncapsulation,
  booleanAttribute,
  computed,
  input,
} from '@angular/core';
import { BarChart } from '../bar-chart/bar-chart.component';
import { DoughnutChart } from '../doughnut-chart/doughnut-chart.component';

export type ChartType = 'bar' | 'pie' | 'doughnut';

export type ChartColor =
  | 'orange'
  | 'red'
  | 'lightblue'
  | 'turquoise'
  | 'darkviolet'
  | 'multi'
  | 'quot';

@Component({
  selector: 'procure-chart',
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.scss',
  imports: [BarChart, DoughnutChart],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class Chart {
  readonly type = input.required<ChartType>();
  readonly dataset = input.required<ChartDatasetModel | undefined | null>();
  readonly color = input.required<ChartColor>();
  readonly suffix = input<string>();

  readonly horizontal = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly hidden = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly colorModifier = computed(() => {
    const color = this.color();
    return color ? `chart chart--${color}` : 'chart';
  });

  protected readonly multiColor = computed(
    () => this.color() === 'multi' || this.color() === 'quot',
  );
}
